var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "casino-sub-navigation" }, [
    _c(
      "ul",
      { staticClass: "casino-sub-nav" },
      _vm._l(_vm.children, function(child) {
        return _c(
          "li",
          { key: child.id, staticClass: "casino-sub-nav-item" },
          [
            ["INTERNAL", "GROUP"].includes(child.linkType)
              ? _c(
                  "router-link",
                  {
                    staticClass: "item-link",
                    attrs: {
                      to: { path: "/" + _vm.$i18n.locale + child.uri || "/" },
                      id: "casino-sub-nav-item-" + child.id,
                      "active-class": "active-sub-item"
                    }
                  },
                  [
                    _c("span", { staticClass: "item-text" }, [
                      _vm._v(_vm._s(child.text))
                    ])
                  ]
                )
              : child.linkType === "URL"
              ? _c(
                  "a",
                  {
                    class: [child.cssClass, "item-link"],
                    attrs: {
                      href: child.uri,
                      setTarget: _vm.setExternalNavigationTarget(
                        "casino-sub-nav-item-" + child.id,
                        child.target
                      ),
                      id: "casino-sub-nav-item-" + child.id,
                      rel: "external",
                      "aria-label": child.text
                    }
                  },
                  [
                    _c("span", { staticClass: "item-text" }, [
                      _vm._v(_vm._s(child.text))
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29ce0869", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ce0869","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoSubNavigation.vue
// module id = null
// module chunks = 